import { Injectable } from '@angular/core';
import {
  UNLOCK_INSIGHTS_PLAN_UPGRADE_ORIGIN_BILLING
} from 'src/app/pages/dashboard/dashboard-team/unlock-insights-panel/unlock-insights.constants';

/**
 * Coordinates Plan Upgraded attribution for Unlock Insights billing redirects, and dedupes
 * dialog vs billing-page emissions for the same upgrade.
 */
@Injectable({ providedIn: 'root' })
export class UnlockInsightsUpgradeTrackingService {
  private billingPageUpgradePending = false;
  private lastDialogTrackedUpgrade: { from: string | undefined, to: string } | null = null;

  markBillingPageUpgradePending(): void {
    this.billingPageUpgradePending = true;
  }

  /** Drop a stale Unlock Insights billing-redirect marker (e.g. user left billing without upgrading). */
  clearBillingPageUpgradePending(): void {
    this.billingPageUpgradePending = false;
  }

  /**
   * After the payment dialog emits Plan Upgraded, remember the transition so the billing page
   * listener can skip a duplicate event. Also clears any Unlock Insights billing-redirect marker.
   */
  markPlanUpgradedTrackedByDialog(from: string | undefined, to: string): void {
    this.lastDialogTrackedUpgrade = { from, to };
    this.billingPageUpgradePending = false;
  }

  /**
   * Returns true when the billing page should skip Plan Upgraded for this transition because the
   * dialog already tracked it. Clears any stored dialog transition after the check.
   */
  wasPlanUpgradedTrackedByDialog(from: string | undefined, to: string): boolean {
    if (!this.lastDialogTrackedUpgrade) {
      return false;
    }

    const match = this.lastDialogTrackedUpgrade.from === from
      && this.lastDialogTrackedUpgrade.to === to;
    this.lastDialogTrackedUpgrade = null;
    return match;
  }

  consumeBillingPageUpgradeOrigin(): typeof UNLOCK_INSIGHTS_PLAN_UPGRADE_ORIGIN_BILLING | null {
    if (!this.billingPageUpgradePending) {
      return null;
    }

    this.billingPageUpgradePending = false;
    return UNLOCK_INSIGHTS_PLAN_UPGRADE_ORIGIN_BILLING;
  }
}
